import React, { FC, useState, useContext } from "react";
import injectSheet from "react-jss";

import styleSheet from "./styles";
import FunnelIcon from "Assets/ui/funnel.svg";
interface Props {
  classes: any;
  className?: string;
  svgFill?: string;
  style?: any;
  wrapperClass?:string;
}
const funnel: FC<Props> = ({
  classes,
  className,
  style,
  svgFill = "#223762", //Default
  wrapperClass
}) => (
  <div className={wrapperClass} style={style}>
    <FunnelIcon className={className} fill={svgFill} />
  </div>
);

export const Funnel = injectSheet(styleSheet)(funnel);
